export default __webpack_public_path__ + "static/media/phoneLogo.a1627c78.svg";